"use client";
import { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import TopBar from "@/component/SharedUI/TopBar";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100dvh",
        minHeight: "100vh",
        //  backgroundColor: "#F4F5F0",
      }}
    >
      <TopBar text="Something went wrong" />

      <Box
        sx={{
          height: "100dvh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          p: 4,
        }}
      >
        <Typography sx={{ fontSize: "32px" }} variant="h5" gutterBottom>
          Something went wrong
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We couldn't load the data. Please try again.
        </Typography>
        <Button
          sx={{
            width: "100%",
            height: 40,
            borderRadius: "100px",
            backgroundColor: "#0A0A0A",
            color: "white !important",
            textTransform: "none",
            fontFamily: "SF Pro",
            fontWeight: 500,
            fontSize: 14,
            mb: 2,
          }}
          variant="contained"
          onClick={() => reset()}
        >
          Retry
        </Button>
        <Button
          sx={{
            width: "100%",
            height: 40,
            borderRadius: "100px",
            backgroundColor: "#E0E0E0",
            color: "#1F1B13",
            textTransform: "none",
            fontFamily: "SF Pro",
            fontWeight: 500,
            fontSize: 14,
          }}
          variant="contained"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          Go to Home
        </Button>
      </Box>
    </Box>
  );
}
